"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordFormView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CommonComponents_1 = require("./CommonComponents");
const utils_1 = require("../utils");
const PasswordReminder = (0, app_1.styled)(app_1.Link) `
  text-align: center;
  color: ${(theme) => theme.colors.gray};
  margin: ${(theme) => theme.spacing.small} 0;
  display: block;
`;
function ResetPasswordFormView({ handleSubmit, className, submitProps, passwordRules, }) {
    const signInPath = (0, app_1.useContextPath)('signIn') || '/login';
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CommonComponents_1.StyledForm, Object.assign({ className: className, onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(CommonComponents_1.StyledTextInput, { label: t('label.password'), name: "password", type: "password", validate: passwordRules !== null && passwordRules !== void 0 ? passwordRules : utils_1.passwordRules }), (0, jsx_runtime_1.jsx)(PasswordReminder, Object.assign({ href: signInPath }, { children: t('info.backToLogIn') })), (0, jsx_runtime_1.jsx)(CommonComponents_1.StyledSubmit, Object.assign({}, submitProps, { children: t('info.resetPassword') }))] })));
}
exports.ResetPasswordFormView = ResetPasswordFormView;
